export const apiConvert = 'convert/candidate/graphql';
export const apiConvertUpload = 'convert/candidate/upload';
export const candidateAuth = 'auth';
export const clientLogger = 'convert/candidate/client-logger';
